"use strict";
/** family: MultiSelect **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component is created to share the common functionality between
 * MultiSelectButton and MultiSelectSearch components.
 *
 * This component takes care of the following common functionalities:
 * 1. Renders a dropdown button
 * 2. Displays the button dropdown label
 * 3. Provide helper function to find the selected items
 * 4. Provide helper function to check if an item is selected
 */
var classNames = require("classnames");
var React = require("react");
var DropdownButton_1 = require("../DropdownButton");
var CLASS_NAME = 'i-multiselect-button';
var MultiSelectCommon = /** @class */ (function (_super) {
    __extends(MultiSelectCommon, _super);
    function MultiSelectCommon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isSelected = function (selectedItems, current) {
            return selectedItems.filter(function (selectedItem) { return selectedItem.value === current.value; }).length > 0;
        };
        _this.getSelectedItemsOnSelect = function (selectedItems, current) {
            if (_this.isSelected(selectedItems, current)) {
                return selectedItems.filter(function (item) { return item.value !== current.value; });
            }
            else {
                return selectedItems.concat(current);
            }
        };
        _this.getLabelDisplayMode = function (selectedItems) {
            return selectedItems.length > 1
                ? LabelDisplayMode.Compact
                : LabelDisplayMode.Full;
        };
        _this.getButtonLabel = function (label, selectedText, selectedItems) {
            var items = _this.getLabelDisplayMode(selectedItems) === LabelDisplayMode.Full
                ? selectedItems.map(function (item) { return item.label; }).join(', ')
                : selectedItems.length + " " + selectedText;
            return "" + label + (items ? ": " + items : '');
        };
        return _this;
    }
    MultiSelectCommon.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, label = _a.label, onToggle = _a.onToggle, onOutsideClick = _a.onOutsideClick, selectedText = _a.selectedText, selectedItems = _a.selectedItems, restProps = __rest(_a, ["children", "className", "label", "onToggle", "onOutsideClick", "selectedText", "selectedItems"]);
        return (React.createElement(DropdownButton_1.DropdownButton, __assign({ className: classNames(CLASS_NAME, className), label: this.getButtonLabel(label, selectedText, selectedItems), role: DropdownButton_1.DropdownButton.Role.ListBox, onToggle: onToggle, onOutsideClick: onOutsideClick }, restProps), children({
            getSelectedItemsOnSelect: this.getSelectedItemsOnSelect,
            isSelected: this.isSelected,
        })));
    };
    return MultiSelectCommon;
}(React.Component));
exports.MultiSelectCommon = MultiSelectCommon;
var LabelDisplayMode;
(function (LabelDisplayMode) {
    LabelDisplayMode["Full"] = "full";
    LabelDisplayMode["Compact"] = "compact";
})(LabelDisplayMode = exports.LabelDisplayMode || (exports.LabelDisplayMode = {}));
//# sourceMappingURL=MultiSelectCommon.js.map